export const TXID_REGEXP = /^[0-9a-fA-F]{64}$/
